<template>
  <div class="container">
    <div class="header-btns">
      <div class="btn">
        <el-button
          :class="`mwow-button-filled warning ${
            multipleSelection.length > 0 ? '' : 'disable'
          }`"
          @click="handleRecover('multi')"
          >批量还原</el-button
        >
      </div>
      <div class="btn">
        <el-button
          :class="`mwow-button-filled danger ${
            multipleSelection.length > 0 ? '' : 'disable'
          }`"
          @click="handleDelete('multi')"
          >批量删除</el-button
        >
      </div>
    </div>
    <common-search-form-wrapper :reset="resetSearch">
      <el-form
        size="mini"
        :model="searchInfo"
        label-width="60px"
        label-position="right"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索:" prop="key_word">
              <el-input
                v-model="searchInfo.key_word"
                placeholder="学员姓名/手机号"
                @change="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="99"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="回收人员:" prop="recycle_staff_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.recycle_staff_id"
                :defaultSelected.sync="searchInfo.recycle_staff_list"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="创建时间:"
              prop="create_date"
              label-width="90px"
            >
              <common-date-range-selector
                v-model="searchInfo.create_date"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="回收时间:" prop="recycle_date">
              <!-- <el-date-picker
                v-model="searchInfo.recycle_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.recycle_date"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出现方式:" class="require">
              <el-select
                v-model="searchInfo.appear_id"
                placeholder="请选择出现方式"
                clearable
                @change="
                  () => {
                    searchInfo.source_type = '';
                    sourceList = [];
                    handleSearchSource();
                    handleSearch();
                  }
                "
              >
                <el-option
                  v-for="item in studentAppearLabelList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="来源渠道:"
              class="source_type"
              label-width="90px"
            >
              <el-select
                v-model="searchInfo.source_type"
                placeholder="请选择来源渠道"
                clearable
                @change="handleSearch"
                @focus="
                  () => {
                    if (!searchInfo.appear_id) {
                      $message({
                        type: 'warning',
                        message: '请先选择出现方式',
                      });
                    }
                  }
                "
              >
                <el-option
                  v-for="item in sourceList"
                  :key="item.source_id"
                  :label="item.name"
                  :value="item.source_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="回收分类:" prop="recycle_category_id">
              <el-select
                v-model.number="searchInfo.recycle_category_id"
                clearable
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="多次未接" :value="1"></el-option>
                <el-option label="距离超过3公里" :value="2"></el-option>
                <el-option label="没意向" :value="3"></el-option>
                <el-option label="年龄不到3岁" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分配次数:" prop="allocate_num">
              <div class="allocate-wrap">
                <el-input
                  v-model="searchInfo.allocate_num_start"
                  type="number"
                  placeholder="最低次数"
                  @change="
                    (v) => {
                      let res = '';
                      if (v !== '') {
                        res = Number(v);
                        if (
                          searchInfo.allocate_num_end !== '' &&
                          res > Number(searchInfo.allocate_num_end)
                        ) {
                          $message({
                            type: 'warning',
                            message: '最低次数不可高于最高次数',
                          });
                          res = '';
                        }
                        if (res < 0) {
                          $message({
                            type: 'warning',
                            message: '最低次数不可小于0',
                          });
                          res = '';
                        }
                        if (res > 99999) {
                          $message({
                            type: 'warning',
                            message: '最低次数数值过大',
                          });
                          res = '';
                        }
                      }
                      searchInfo.allocate_num_start =
                        res !== '' ? Math.floor(res) : '';
                      handleSearch();
                    }
                  "
                ></el-input>
                <span>至</span>
                <el-input
                  v-model="searchInfo.allocate_num_end"
                  type="number"
                  placeholder="最高次数"
                  @change="
                    (v) => {
                      let res = '';
                      if (v !== '') {
                        res = Number(v);
                        if (
                          searchInfo.allocate_num_start !== '' &&
                          res < Number(searchInfo.allocate_num_start)
                        ) {
                          $message({
                            type: 'warning',
                            message: '最高次数不可低于最高次数',
                          });
                          res = '';
                        }
                        if (res < 0) {
                          $message({
                            type: 'warning',
                            message: '最高次数不可小于0',
                          });
                          res = '';
                        }
                        if (res > 99999) {
                          $message({
                            type: 'warning',
                            message: '最高次数数值过大',
                          });
                          res = '';
                        }
                      }
                      searchInfo.allocate_num_end =
                        res !== '' ? Math.floor(res) : '';
                      handleSearch();
                    }
                  "
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="最近跟进时间:"
              prop="follow_time"
              label-width="90px"
            >
              <!-- <el-date-picker
                v-model="searchInfo.follow_time"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.follow_time"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      class="mwow-table"
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      @sort-change="clickStort"
      ref="main-table"
    >
      <el-table-column
        type="selection"
        width="52"
        align="center"
      ></el-table-column>
      <el-table-column label="学员姓名" prop="name">
        <template slot-scope="scope">
          <span
            v-if="scope.row.name"
            class="mwow-green"
            style="cursor: pointer"
            @click="toStudentDetail(scope.row)"
            >{{ scope.row.name }}</span
          >
          <span v-else>-</span>
          <span v-if="scope.row.is_del === 1" class="mwow-tag del-filled large"
            >已删除</span
          >
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="mobile" min-width="160">
        <template slot-scope="scope">
          {{ "+" + scope.row.area_code }} {{ scope.row.mobile || "-" }}
          <el-popover
            placement="top"
            popper-class="followuppopover"
            trigger="hover"
          >
            <p style="text-align: center">
              {{ `${scope.row.wechat_status === 0 ? "未" : "已"}绑定微信` }}
            </p>
            <i
              class="iconfont icon-wechat"
              slot="reference"
              :style="`margin-left:6px;font-size:15px;color:${
                scope.row.wechat_status === 0 ? '#CCCCCC' : '#01D20B'
              }`"
            ></i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="分配次数"
        prop="allocate_num"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        width="100"
      ></el-table-column>
      <el-table-column
        label="最近分配时间"
        prop="allocate_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column
        label="最近跟进时间"
        prop="follow_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column
        prop="follow_log.content"
        label="最近跟进内容"
        width="270"
      >
        <template slot-scope="scope">{{
          scope.row.follow_log ? scope.row.follow_log.content || "-" : "-"
        }}</template>
      </el-table-column>
      <el-table-column
        label="最近跟进课程顾问"
        prop="last_follow_staff.name"
        min-width="120"
      >
        <template slot-scope="scope">{{
          scope.row.last_follow_staff
            ? scope.row.last_follow_staff.name || "-"
            : "-"
        }}</template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        width="140"
      ></el-table-column>
      <el-table-column label="出现方式" prop="appear_id">
        <template slot-scope="scope">
          {{ handleAppear(scope) }}
        </template>
      </el-table-column>
      <el-table-column
        label="来源渠道"
        prop="student_source.name"
      ></el-table-column>
      <el-table-column label="回收人员" prop="recycle_staff">
        <template slot-scope="scope">
          <span v-if="scope.row.recycle_staff">{{
            scope.row.recycle_staff.name || "-"
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="回收时间"
        prop="recycle_time"
        width="140"
      ></el-table-column>
      <el-table-column label="回收分类" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.recycle_category_id === 1">多次未接</div>
          <div v-if="scope.row.recycle_category_id === 2">距离超过3公里</div>
          <div v-if="scope.row.recycle_category_id === 3">没意向</div>
          <div v-if="scope.row.recycle_category_id === 4">年龄不到3岁</div>
        </template>
      </el-table-column>
      <el-table-column
        label="回收原因"
        width="280"
        class-name="recycleStudentCon"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.recycle_remark">
            <el-popover
              placement="top-start"
              title="回收原因"
              width="200"
              trigger="hover"
              :content="scope.row.recycle_remark"
            >
              <span slot="reference">
                {{ scope.row.recycle_remark }}
              </span>
            </el-popover>
          </span>
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="190">
        <template slot-scope="scope">
          <div class="table-btns">
            <el-button
              class="mwow-button warning"
              @click="handleRecover('single', scope.row.student_id)"
              >还原</el-button
            >
            <el-button
              class="mwow-button primary"
              @click="handleView(scope.row.student_id)"
              >查看</el-button
            >
            <el-button
              class="mwow-button info"
              @click="handleDelete('single', scope.row)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 还原弹窗 -->
    <recycle-dialog
      :student-ids="studentIds"
      :visible.sync="dialogVisible"
      @close="
        () => {
          handlePrePage(
            courseTeacherInfo.type === 'single' ? 1 : multipleSelection.length
          );
        }
      "
    ></recycle-dialog>
  </div>
</template>
<script>
import { PageModule } from "@/store/module/page";
import { getRecycleStudentListApi } from "@/api/studentManage";
import eventBus from "@/utils/bus";
import { deldetails } from "@/api/studyDetails";
import { dateFormat } from "@/utils/timeFormat";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import recycleDialog from "./recycleDialog.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
export default {
  props: ["visible"],
  components: {
    commonStaffPullDown,
    commonSearchFormWrapper,
    recycleDialog,
    commonDateRangeSelector,
  },
  data() {
    return {
      dialogVisible: false,
      courseTeacherInfo: {
        type: "",
      },
      searchInfo: {
        key_word: "",
        recycle_staff_id: "",
        create_date: [],
        recycle_date: [],
        recycle_category_id: "",
        appear_id: "",
        source_type: "",
        allocate_num_start: "",
        allocate_num_end: "",
        follow_time: [],
        sort_type: "desc",
        sort_field: "create_time",
      },
      tableData: [],
      multipleSelection: [],
      studentIds: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      sourceList: [],
      studentAppearLabelList: [],
    };
  },
  created() {
    eventBus.$on("latent-list-update-recycle", () => {
      const table = this.$refs["main-table"];
      table.clearSelection();
      this.handleRefresh();
    });
    if (PageModule.latestRoute === "studyDetails") {
      const cache = PageModule.pageInfo.recruitRecycleList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      getStudentAppearListApi({
        page: 1,
        page_size: 500,
      }).then((res) => {
        this.studentAppearLabelList = res.data.list;
      });
      this.handleRefresh();
    },
    resetSearch() {
      this.searchInfo = {
        key_word: "",
        recycle_staff_id: "",
        create_date: [],
        recycle_date: [],
        recycle_category_id: "",
        appear_id: "",
        source_type: "",
        allocate_num_start: "",
        allocate_num_end: "",
        follow_time: [],
        sort_type: this.searchInfo.sort_type,
        sort_field: this.searchInfo.sort_field,
      };
      this.handleSearch();
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    // 删除行后判断是否倒退一页
    handlePrePage(number) {
      let page = this.page;
      if (number >= this.tableData.length) {
        page = page - 1;
      }
      this.getList({
        page: page > 0 ? page : 1,
        page_size: this.pageSize,
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.key_word) {
        option.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.recycle_staff_id !== "") {
        option.recycle_staff_id = this.searchInfo.recycle_staff_id;
      }
      if (
        this.searchInfo.create_date &&
        this.searchInfo.create_date.length === 2
      ) {
        option.start_time = this.searchInfo.create_date[0].getTime() / 1000;
        option.end_time =
          this.searchInfo.create_date[1].getTime() / 1000 + 24 * 60 * 60 - 1;
      }
      if (
        this.searchInfo.recycle_date &&
        this.searchInfo.recycle_date.length === 2
      ) {
        option.recycle_start_time =
          new Date(this.searchInfo.recycle_date[0] + " 00:00:01").getTime() /
          1000;
        option.recycle_end_time =
          new Date(this.searchInfo.recycle_date[1] + " 23:59:59").getTime() /
          1000;
      }
      if (this.searchInfo.recycle_category_id !== "") {
        option.recycle_category_id = this.searchInfo.recycle_category_id;
      }
      if (this.searchInfo.appear_id !== "") {
        option.appear_id = this.searchInfo.appear_id;
      }
      if (this.searchInfo.source_type !== "") {
        option.source_type = this.searchInfo.source_type;
      }
      if (this.searchInfo.allocate_num_start !== "") {
        option.allocate_num_start = Number(this.searchInfo.allocate_num_start);
      }
      if (this.searchInfo.allocate_num_end !== "") {
        option.allocate_num_end = Number(this.searchInfo.allocate_num_end);
      }
      if (
        this.searchInfo.follow_time &&
        this.searchInfo.follow_time.length === 2
      ) {
        option.follow_start_time = this.searchInfo.follow_time[0];
        option.follow_end_time = this.searchInfo.follow_time[1];
      }
      if (
        this.searchInfo.sort_type !== "" &&
        this.searchInfo.sort_field !== ""
      ) {
        option.sort_type = this.searchInfo.sort_type;
        option.sort_field = this.searchInfo.sort_field;
      }
      getRecycleStudentListApi(option).then((res) => {
        this.page = res.data.page;
        this.total = res.data.total;
        res.data.list.map((item) => {
          item.create_time = dateFormat("YYYY-mm-dd", item.create_time * 1000);
          item.recycle_time = dateFormat(
            "YYYY-mm-dd",
            item.recycle_time * 1000
          );
          item.allocate_time = dateFormat(
            "YYYY-mm-dd",
            item.allocate_time * 1000
          );
          item.follow_time = dateFormat("YYYY-mm-dd", item.follow_time * 1000);
        });
        this.tableData = res.data.list;
        if (res.data.page > 1 && res.data.list.length === 0) {
          this.handleSearch();
        }
      });
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },
    handleRecover(type, id) {
      if (type === "single") {
        if (!id) {
          return false;
        }
        this.studentIds = [id];
      } else {
        if (this.multipleSelection.length === 0) {
          return false;
        }
        this.studentIds = [];
        this.multipleSelection.map((item) => {
          this.studentIds.push(item.student_id);
        });
      }
      this.courseTeacherInfo.type = type;
      this.dialogVisible = true;
    },
    handleDelete(type, row) {
      let ids = [];
      let names = [];
      if (type === "single") {
        if (!row) {
          return false;
        }
        ids = [row.student_id];
        names = [row.name];
      } else {
        if (this.multipleSelection.length === 0) {
          return false;
        }
        this.multipleSelection.map((item) => {
          ids.push(item.student_id);
          names.push(item.name);
        });
      }
      this.$confirm(
        "删除后，学员基本信息等数据将被清除，此操作不能撤销。",
        `删除 - ${names.join("、")}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          deldetails({ student_ids: ids }).then((res) => {
            if (res.data.check === false) {
              this.$alert(
                `选择学员中已有订单记录，如需删除请废除学员所有订单后，再进行删除。`,
                `无法删除`,
                {
                  confirmButtonText: "关闭",
                  confirmButtonClass: "mwow-button-filled mini",
                  iconClass: "mwow-icon-error",
                }
              );
            } else {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handlePrePage(
                type === "single" ? 1 : this.multipleSelection.length
              );
            }
          });
        })
        .catch(() => {});
    },
    handleView(id) {
      PageModule.SET_PAGE_INFO({
        name: "recruitRecycleList",
        key: "search_info",
        value: { ...this.searchInfo },
      });
      this.$router.push({
        name: "studyDetails",
        query: { id: String(id), tab: "followup" },
      });
    },
    handleSearchSource() {
      if (!this.searchInfo.appear_id) {
        return false;
      }
      sourceTypeSelectListApi({
        appear_id: this.searchInfo.appear_id,
      }).then((res) => {
        if (res.error_code === 0) {
          this.sourceList = res.data.list;
        }
      });
    },
    handleAppear(scope) {
      let target = this.studentAppearLabelList.find((item) => {
        return scope.row.appear_id === item.id;
      });
      if (target) {
        return target.name;
      } else {
        return "-";
      }
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "recruitRecycleList",
        key: "page",
        value: e,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    beforeDestroy() {
      eventBus.$off("latent-list-update-recycle");
    },
    toStudentDetail(row) {
      this.$router.push({
        name: "studyDetails",
        query: { id: row.student_id, tab: "followup" },
      });
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.handleSearch();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.header-btns {
  margin-bottom: 12px;
  .btn {
    margin-right: 20px;
    display: inline-block;
  }
}
.table-btns {
  .el-button {
    margin: 0 4px;
  }
}
.form-btn {
  display: flex;
  justify-content: end;
  :nth-child(1) {
    margin-right: 10px;
  }
}
/deep/ .recycleStudentCon {
  .cell {
    width: 23em;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*禁止换行*/
    text-overflow: ellipsis;
  }
}
.allocate-wrap {
  display: flex;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  line-height: 30px;
  height: 30px !important;
  position: relative;
  .el-input {
    width: 165px;
  }
  /deep/.el-input__inner {
    border: none !important;
  }
  span {
    margin: 0 10px 0 0;
  }
  .el-input {
    width: auto;
    text-align: center;
  }
}
</style>
